import { SectionTitle } from "../../PresentationalComponents/SectionTitle";
import styles from "./LatestUpdates.module.css";
import { Update } from "./Update";
import { useTranslation } from "react-i18next";

const latestUpdatesList = [
  {
    date: { fa: "تیر ۱۴۰۵", en: "JUL 2026" },
    description: {
      fa: "فراگیری دوره‌های HTML, CSS و Javascript",
      en: "Mastering HTML, CSS, and JS",
    },
    type: { fa: "آموزشی", en: "Education" },
  },
  {
    date: { fa: "مرداد ۱۴۰۵", en: "AUG 2026" },
    description: {
      fa: "پروژه لوکس موبایل - فروشگاه موبایل طرح اصلی",
      en: "LuxMobile - Shopping Website For Fake Phones",
    },
    type: { fa: "پروژه", en: "Project" },
    color: { fa: "orange", en: "orange" },
  },
  {
    date: { fa: "مرداد ۱۴۰۵", en: "AUG 2026" },
    description: {
      fa: "پروژه آلفادکور - شرکت طراحی دکوراسیون داخلی",
      en: "Alpha Decor - Interior Designer",
    },
    type: { fa: "پروژه", en: "Project" },
  },
  {
    date: { fa: "شهریور ۱۴۰۵", en: "SEP 2026" },
    description: {
      fa: "کسب رتبه برتر در کنکور سراسری ارشد مهندسی کامپیوتر",
      en: "Acheiving High rank in University Entrance Exam in Master's degree",
    },
    type: { fa: "دستاورد", en: "Achievement" },
  },
];

export function LatestUpdates({ t }) {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const updates = [];
  for (let i = latestUpdatesList.length - 1; i >= 0; i--) {
    updates.push(
      <Update
        date={latestUpdatesList[i].date[lang]}
        description={latestUpdatesList[i].description[lang]}
        type={latestUpdatesList[i].type[lang]}
        alpha={((i + 1.5) * 100) / latestUpdatesList.length + "%"}
        key={i}
      />,
    );
  }

  return (
    <section className={styles.sectionContainer}>
      <SectionTitle
        text={t("LatestUpdates.section-name")}
        num={t("LatestUpdates.section-num")}
      />
      <div className={styles.latestContainer}>{updates}</div>
    </section>
  );
}
